import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, CardMedia } from '@mui/material';
const IframeScreen = () => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    const storedUrl = localStorage.getItem('iframeUrl');
    setUrl(storedUrl);
  }, []);

  return (
    <Box sx={{ width: '100vw', height: '100vh', backgroundColor: '#eee' }}>
      {url ? (
        <iframe src={url} title="iframe-content" style={{ width: '100%', height: '100%', border: 'none' }} />
      ) : (
        <Typography variant="h6">Invalid URL</Typography>
      )}
    </Box>
  );
};
export default IframeScreen;